import { ServiceFeeDto } from "@up/data";

export function calculateServiceFeeAmount(orderTotal: number, serviceFee: ServiceFeeDto): number {
    if(!serviceFee) return null;

    const { percent, minAmount, maxAmount } = serviceFee || {};
    let serviceFeeAmount = orderTotal * (percent / 100);
  
    if (minAmount !== null && serviceFeeAmount < minAmount) {
      serviceFeeAmount = minAmount;
    }
  
    if (maxAmount !== null && serviceFeeAmount > maxAmount) {
      serviceFeeAmount = maxAmount;
    }
  
    return +serviceFeeAmount.toFixed(2);
}